import { render, staticRenderFns } from "./modifyAddress.vue?vue&type=template&id=2a2912ba&scoped=true&"
import script from "./modifyAddress.vue?vue&type=script&lang=js&"
export * from "./modifyAddress.vue?vue&type=script&lang=js&"
import style0 from "./modifyAddress.vue?vue&type=style&index=0&id=2a2912ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2912ba",
  null
  
)

export default component.exports